import React, { useState } from "react";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";
import { toast } from "react-toastify";
import LoaderPage from "./Loader";

const RequestCallback = () => {
    const [formData, setFormData] = useState({
        name: "",
        mobileNumber: "",
        orderId: "",
        email: "",
        description: "",
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let temp = {};

        if (!formData.name.trim()) temp.name = "Name is required";

        if (!formData.mobileNumber.trim())
            temp.mobileNumber = "Mobile number is required";
        else if (!/^[6-9]\d{9}$/.test(formData.mobileNumber))
            temp.mobileNumber = "Enter a valid 10-digit mobile number";

        if (!formData.orderId.trim()) temp.orderId = "Order ID is required";

        if (!formData.email.trim()) temp.email = "Email is required";
        else if (!/^\S+@\S+\.\S+$/.test(formData.email))
            temp.email = "Enter a valid email";

        if (!formData.description.trim())
            temp.description = "Description is required";

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        try {
            setLoading(true);
            const res = await axios.post(
                `${endPoint.RequestCallback}`,
                formData
            );
            toast.success("Callback request submitted successfully!");
            setFormData({
                name: "",
                mobileNumber: "",
                orderId: "",
                email: "",
                description: "",
            });
        }
        catch (error) {
            toast.error("Failed to submit callback request. Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex justify-center items-center px-4"
            style={{ backgroundColor: "#F0EBE3" }}
        >
            <div className="w-full max-w-5xl bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden grid grid-cols-1 md:grid-cols-2">

                <div className="hidden md:flex flex-col justify-center items-center bg-gradient-to-br from-blue-600 to-purple-700 text-white p-10">
                    <lottie-player
                        src="https://assets5.lottiefiles.com/packages/lf20_jcikwtux.json"
                        background="transparent"
                        speed="1"
                        style={{ width: "260px", height: "260px" }}
                        loop
                        autoplay
                    ></lottie-player>

                    <h2 className="text-3xl font-bold mt-6">We're Here to Help!</h2>
                    <p className="text-gray-200 mt-2 text-center">
                        Share your details and a specialist will call you shortly.
                    </p>
                </div>

                <div className="p-8 md:p-10">
                    <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-6">
                        Request a Callback
                    </h1>

                    <form onSubmit={handleSubmit} className="space-y-6">

                        {[
                            { label: "Name", key: "name", type: "text" },
                            { label: "Mobile Number", key: "mobileNumber", type: "tel" },
                            { label: "Order ID", key: "orderId", type: "text" },
                            { label: "Email", key: "email", type: "email" },
                        ].map((field) => (
                            <div className="relative" key={field.key}>
                                <input
                                    type={field.type}
                                    placeholder=" "
                                    className="peer w-full p-3 h-14 border border-gray-300 rounded-xl 
                                    focus:border-blue-500 focus:ring-2 focus:ring-blue-300 outline-none transition"
                                    value={formData[field.key]}
                                    onChange={(e) =>
                                        setFormData({ ...formData, [field.key]: e.target.value })
                                    }
                                />
                                <label
                                    className="
                                        absolute left-3 top-4 
                                        text-gray-500 text-sm 
                                        transition-all duration-200
                                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-sm
                                        peer-focus:top-1 peer-focus:text-xs peer-focus:text-blue-600
                                        peer-valid:top-1 peer-valid:text-xs
                                    "
                                >
                                    {field.label}
                                </label>

                                {errors[field.key] && (
                                    <p className="text-red-600 text-sm mt-1">
                                        {errors[field.key]}
                                    </p>
                                )}
                            </div>
                        ))}

                        <div className="relative">
                            <textarea
                                placeholder=" "
                                rows={4}
                                className="peer w-full p-3 h-32 border border-gray-300 rounded-xl 
                                focus:border-blue-500 focus:ring-2 focus:ring-blue-300 outline-none transition"
                                value={formData.description}
                                onChange={(e) =>
                                    setFormData({ ...formData, description: e.target.value })
                                }
                            />
                            <label
                                className="
                                    absolute left-3 top-4 
                                    text-gray-500 text-sm 
                                    transition-all duration-200
                                    peer-placeholder-shown:top-4 peer-placeholder-shown:text-sm
                                    peer-focus:top-1 peer-focus:text-xs peer-focus:text-blue-600
                                "
                            >
                                Description
                            </label>

                            {errors.description && (
                                <p className="text-red-600 text-sm mt-1">
                                    {errors.description}
                                </p>
                            )}
                        </div>

                        <button
                            type="submit"
                            className="w-full py-3 bg-gradient-to-r from-blue-600 to-purple-600 
                            text-white font-bold text-lg rounded-xl shadow-md hover:opacity-90 transition"
                        >
                            Submit Request
                        </button>
                    </form>
                </div>
            </div>
            {loading && <LoaderPage />}
        </div>
    );
};

export default RequestCallback;
